/** Owner-confirmed Google Business Profile hours, in Bangladesh local time. */
export const BUSINESS_HOURS = {
  timeZone: "Asia/Dhaka",
  openDays: ["Saturday", "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday"],
  closedDay: "Friday",
  opens: "09:00",
  closes: "17:00",
  en: "Saturday–Thursday, 9am–5pm · Closed Friday · Bangladesh time (UTC+6)",
  bn: "শনিবার–বৃহস্পতিবার, সকাল ৯টা–বিকেল ৫টা · শুক্রবার বন্ধ · বাংলাদেশ সময় (UTC+৬)",
};

export const BUSINESS_HOURS_SPECIFICATION = [
  {
    "@type": "OpeningHoursSpecification",
    dayOfWeek: BUSINESS_HOURS.openDays,
    opens: BUSINESS_HOURS.opens,
    closes: BUSINESS_HOURS.closes,
  },
  {
    "@type": "OpeningHoursSpecification",
    dayOfWeek: [BUSINESS_HOURS.closedDay],
    opens: "00:00",
    closes: "00:00",
  },
];